import { type User, getAuth } from 'firebase/auth';

export function getCurrentUser(): Promise<User | null> {
  return new Promise((resolve, reject) => {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (currentUser != null) {
      return resolve(currentUser);
    }

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }

      return resolve(user);
    }, reject);
  });
}
